import React from 'react'
import PropTypes from 'prop-types'
import { Link, ThemeProvider } from '@deseretbook/react-ui'

/**
 * Video Discovery view for individual variants
 *
 * @param {string} id Variant Sku
 * @param {string} image Image for the
 * @param {object} variant Object with the slug needed for redirect
 *
 * @returns {function} React Component
 */
export const Sku = ({ id, image, variant }) => {
  const { name, slug, error } = variant

  if (error) {
    return (
      <div className="detailed-product-card is-loaded">
        {error} {id}
      </div>
    )
  }

  return (
    <ThemeProvider>
      <Link href={`/p/${slug}?variant_id=${id}-video-on-demand-vod-`} aria-label={name}>
        <img src={image} alt={name} width="100%" height="200%" />
      </Link>
    </ThemeProvider>
  )
}

Sku.propTypes = {
  id: PropTypes.string,
  image: PropTypes.string,
  variant: PropTypes.shape({
    name: PropTypes.string,
    slug: PropTypes.string,
    error: PropTypes.string,
  }),
}
